import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

/** Shareable stand-alone player page for the TailorWiz explainer video.
 *  Send people to tailorwiz.com/watch — no nav, no clutter, one CTA. */
export default function WatchDemo() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#0B1C3F] via-[#0E2350] to-[#0B1C3F] text-white flex flex-col">
      <div className="flex-1 flex flex-col items-center justify-center px-4 py-10">
        <Link to="/" className="text-2xl font-extrabold tracking-tight text-white no-underline">
          Tailor<span className="text-[#C9A84C]">Wiz</span>
        </Link>
        <h1 className="mt-3 text-center text-[22px] sm:text-[30px] font-extrabold tracking-tight">
          Tailor Your Resume to <span className="text-[#C9A84C]">ANY Job</span> in Seconds
        </h1>
        <p className="mt-1 text-sm sm:text-base text-slate-300">Here&apos;s how it works.</p>

        <div className="mt-6 w-full max-w-4xl rounded-2xl overflow-hidden border border-[#C9A84C]/40 shadow-2xl bg-black">
          <video
            src="/videos/tailorwiz-explainer.mp4"
            className="w-full block"
            controls
            autoPlay
            playsInline
          />
        </div>

        <Link
          to="/pricing"
          className="mt-8 inline-flex items-center gap-2 px-8 py-4 rounded-full bg-[#C9A84C] text-[#0B1C3F] text-[16px] font-bold tracking-tight shadow-lg shadow-[#C9A84C]/30 hover:bg-[#E5C36A] transition-all no-underline"
        >
          Try It Out FREE Now
          <ArrowRight className="w-4 h-4" />
        </Link>
        <p className="mt-3 text-[12px] text-slate-400">No credit card needed. Cancel anytime.</p>
      </div>
    </div>
  );
}
